// Section constants for Food preferences v2. Enum options (diet types,
// non-veg sub-options, cuisines, exclusive-group mutex rule) come from the
// backend `/config` call — nothing enum-related is hardcoded here.

// Four search-driven chip lists in the Food behavior card. All four use the
// federated ingredient catalog (api-recipes-service). No subheadings — the
// mock renders them as a flat vertical stack under the "Food behavior" title.
//
// The `key` fields double as the FoodBehavior JSON keys sent to the server,
// so keep them in sync with the backend model.
export const FOOD_BEHAVIOR_FIELDS = [
  {
    key: "likes",
    label: "Likes",
    placeholder: "Search foods — e.g., Spinach , Green Tea , Honey",
  },
  {
    key: "dislikes",
    label: "Dislikes",
    placeholder: "Search foods the patient avoids by taste",
  },
  {
    key: "restrictions",
    label: "Restrictions",
    placeholder: "Search foods — e.g., Spinach , Green Tea , Honey",
  },
  {
    key: "limitations",
    label: "Limitations",
    placeholder: "Items consumed in moderation",
  },
];

// Beforeunload copy shown when the user tries to leave with unsaved changes.
// Modern browsers ignore custom text and show their own dialog, but we still
// set the returnValue to trigger the prompt.
export const UNSAVED_WARN = "You have unsaved changes to Food preferences. Leave anyway?";
